import {createInjectionState} from '@vueuse/core'
import {computed, ref} from 'vue'

const [useProvideDropdown, useDropdown] = createInjectionState((
) => {

  const openedDropdownsIds = ref<symbol[]>([])

  const addDropdown = (id: symbol) => {
    if (!openedDropdownsIds.value.includes(id)) {
      openedDropdownsIds.value.push(id)
    }
  }

  const removeDropdown = (id: symbol) => {
    const index = openedDropdownsIds.value.indexOf(id)
    if (index !== -1) {
      openedDropdownsIds.value.splice(index, 1)
    }
  }

  const isDropdownOpen = computed(() => {
    return openedDropdownsIds.value.length > 0
  })

  return {
    openedDropdownsIds,
    addDropdown,
    removeDropdown,
    isDropdownOpen,
  }
})

export {useProvideDropdown, useDropdown}

